import { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'

function InstagramFeed() {
  const elements = [
    {
      id: 'BFqOSyqfN3rXnO8m',
      name: 'blackstarfotos'
    },
    {
      id: '5QlvZf5KTOioUN3n',
      name: 'blackstarvideos'
    }
  ];

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widget.rss.app/v1/carousel.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [])

  return (
    <Container>
      <Row className='text-center'>
        <span className='cloister-black' style={{ color: '#FFF', fontSize: '60px', marginBottom: '50px' }}>Nosso Portfólio</span>
        <Col>
          {elements.map((element, index) => (
            <rssapp-carousel key={element.id} id={element.id}></rssapp-carousel>
          ))}
        </Col>
      </Row>
    </Container>
  )
}

export default InstagramFeed